import { Component, input } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';

import { UiBadgeTone } from './ui-badge.types';

@Component({
  selector: 'ui-badge',
  standalone: true,
  imports: [MatChipsModule],
  templateUrl: './ui-badge.component.html'
})
export class UiBadgeComponent {
  readonly label = input('');
  readonly tone = input<UiBadgeTone>('active');
}
